const map = {
	"./de/common.json": [
		"./public/locales/de/common.json",
		[
			"public_locales_de_common_json"
		]
	],
	"./de/embed.json": [
		"./public/locales/de/embed.json",
		[
			"public_locales_de_embed_json"
		]
	],
	"./de/moderationHub.json": [
		"./public/locales/de/moderationHub.json",
		[
			"public_locales_de_moderationHub_json"
		]
	],
	"./de/observation.json": [
		"./public/locales/de/observation.json",
		[
			"public_locales_de_observation_json"
		]
	],
	"./de/packageSetup.json": [
		"./public/locales/de/packageSetup.json",
		[
			"public_locales_de_packageSetup_json"
		]
	],
	"./de/rubric.json": [
		"./public/locales/de/rubric.json",
		[
			"public_locales_de_rubric_json"
		]
	],
	"./de/upload.json": [
		"./public/locales/de/upload.json",
		[
			"public_locales_de_upload_json"
		]
	],
	"./en/common.json": [
		"./public/locales/en/common.json",
		[
			"public_locales_en_common_json"
		]
	],
	"./en/embed.json": [
		"./public/locales/en/embed.json",
		[
			"public_locales_en_embed_json"
		]
	],
	"./en/moderationHub.json": [
		"./public/locales/en/moderationHub.json",
		[
			"public_locales_en_moderationHub_json"
		]
	],
	"./en/observation.json": [
		"./public/locales/en/observation.json",
		[
			"public_locales_en_observation_json"
		]
	],
	"./en/packageSetup.json": [
		"./public/locales/en/packageSetup.json",
		[
			"public_locales_en_packageSetup_json"
		]
	],
	"./en/rubric.json": [
		"./public/locales/en/rubric.json",
		[
			"public_locales_en_rubric_json"
		]
	],
	"./en/upload.json": [
		"./public/locales/en/upload.json",
		[
			"public_locales_en_upload_json"
		]
	],
	"./es/common.json": [
		"./public/locales/es/common.json",
		[
			"public_locales_es_common_json"
		]
	],
	"./es/embed.json": [
		"./public/locales/es/embed.json",
		[
			"public_locales_es_embed_json"
		]
	],
	"./es/moderationHub.json": [
		"./public/locales/es/moderationHub.json",
		[
			"public_locales_es_moderationHub_json"
		]
	],
	"./es/observation.json": [
		"./public/locales/es/observation.json",
		[
			"public_locales_es_observation_json"
		]
	],
	"./es/packageSetup.json": [
		"./public/locales/es/packageSetup.json",
		[
			"public_locales_es_packageSetup_json"
		]
	],
	"./es/rubric.json": [
		"./public/locales/es/rubric.json",
		[
			"public_locales_es_rubric_json"
		]
	],
	"./es/upload.json": [
		"./public/locales/es/upload.json",
		[
			"public_locales_es_upload_json"
		]
	],
	"./ja/common.json": [
		"./public/locales/ja/common.json",
		[
			"public_locales_ja_common_json"
		]
	],
	"./ja/embed.json": [
		"./public/locales/ja/embed.json",
		[
			"public_locales_ja_embed_json"
		]
	],
	"./ja/moderationHub.json": [
		"./public/locales/ja/moderationHub.json",
		[
			"public_locales_ja_moderationHub_json"
		]
	],
	"./ja/observation.json": [
		"./public/locales/ja/observation.json",
		[
			"public_locales_ja_observation_json"
		]
	],
	"./ja/packageSetup.json": [
		"./public/locales/ja/packageSetup.json",
		[
			"public_locales_ja_packageSetup_json"
		]
	],
	"./ja/rubric.json": [
		"./public/locales/ja/rubric.json",
		[
			"public_locales_ja_rubric_json"
		]
	],
	"./ja/upload.json": [
		"./public/locales/ja/upload.json",
		[
			"public_locales_ja_upload_json"
		]
	],
	"./mi/common.json": [
		"./public/locales/mi/common.json",
		[
			"public_locales_mi_common_json"
		]
	],
	"./mi/embed.json": [
		"./public/locales/mi/embed.json",
		[
			"public_locales_mi_embed_json"
		]
	],
	"./mi/moderationHub.json": [
		"./public/locales/mi/moderationHub.json",
		[
			"public_locales_mi_moderationHub_json"
		]
	],
	"./mi/observation.json": [
		"./public/locales/mi/observation.json",
		[
			"public_locales_mi_observation_json"
		]
	],
	"./mi/packageSetup.json": [
		"./public/locales/mi/packageSetup.json",
		[
			"public_locales_mi_packageSetup_json"
		]
	],
	"./mi/rubric.json": [
		"./public/locales/mi/rubric.json",
		[
			"public_locales_mi_rubric_json"
		]
	],
	"./mi/upload.json": [
		"./public/locales/mi/upload.json",
		[
			"public_locales_mi_upload_json"
		]
	],
	"./zh/common.json": [
		"./public/locales/zh/common.json",
		[
			"public_locales_zh_common_json"
		]
	],
	"./zh/embed.json": [
		"./public/locales/zh/embed.json",
		[
			"public_locales_zh_embed_json"
		]
	],
	"./zh/moderationHub.json": [
		"./public/locales/zh/moderationHub.json",
		[
			"public_locales_zh_moderationHub_json"
		]
	],
	"./zh/observation.json": [
		"./public/locales/zh/observation.json",
		[
			"public_locales_zh_observation_json"
		]
	],
	"./zh/packageSetup.json": [
		"./public/locales/zh/packageSetup.json",
		[
			"public_locales_zh_packageSetup_json"
		]
	],
	"./zh/rubric.json": [
		"./public/locales/zh/rubric.json",
		[
			"public_locales_zh_rubric_json"
		]
	],
	"./zh/upload.json": [
		"./public/locales/zh/upload.json",
		[
			"public_locales_zh_upload_json"
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./public/locales lazy recursive ^\\.\\/.*\\/.*\\.json$ referencedExports: default";
module.exports = webpackAsyncContext;